import { I18nThemed } from 'interfaces/mixins';
import { v, w } from '@dojo/framework/core/vdom';
import { Radio } from '@dojo/widgets/radio';
import css from '../css/form.m.css';
export class FormSelection extends I18nThemed {
    render() {
        const { title: labeltext, id: name, fgFormat, fgVocabulary, formdata } = this.properties;
        const label = v('legend', { for: name }, [labeltext]);
        let kids = [];
        if (fgFormat === 'radio') {
            kids = fgVocabulary.map((item) => {
                const parts = item.split('|');
                const value = parts[0];
                const label = parts[parts.length - 1];
                const checked = value === formdata[name];
                return w(Radio, {
                    aria: { checked: `${checked}`, role: 'radio', label: label },
                    name,
                    checked,
                    value,
                    onValue: (checked) => {
                        if (checked) {
                            formdata[name] = value;
                        }
                        this.invalidate();
                    }
                }, [{ label }]);
            });
            return v('fieldset', { classes: [this.theme(css.formRadioFieldset)] }, [
                label,
                v('div', { role: 'radiogroup', classes: ['fg-selection-field'] }, kids)
            ]);
        }
        else {
            return v('p', { style: { color: 'red' } }, [`Processor doesn't understand fgFormat=${fgFormat}`]);
        }
    }
}
